export default __webpack_public_path__ + "static/media/info.10cee47e.svg";